import { Splide } from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";


const carousel = () => {
  const targetElms = document.getElementsByClassName('js-sliderBasic');
  if(targetElms.length === 0) return;
  for(const targetElm of targetElms) {
    const speed = 400;
    let options = {
      type: "slide",
      speed: speed,
      rewindSpeed: speed,
      autoWidth: true,
      gap: "0.5rem",
      arrows: false,
      pagination: false,
      reduceMotion: {
        speed: speed,
        rewindSpeed: speed,
        autoplay: true,
      }
    }
    if(targetElm.dataset.speed) {
      options.speed = parseInt(targetElm.dataset.speed);
      options.rewindSpeed = parseInt(targetElm.dataset.speed);
      options.reduceMotion.speed = parseInt(targetElm.dataset.speed);
      options.reduceMotion.rewindSpeed = parseInt(targetElm.dataset.speed);
    }

    if(targetElm.dataset.gap) {
      options.gap = targetElm.dataset.gap;
    }

    const slider = new Splide(elm, options);
    slider.mount();
  }
}

const marquee = () => {
  const targetElms = document.getElementsByClassName('js-sliderMarquee');
  if(targetElms.length === 0) return;
  for(const targetElm of targetElms) {
    let options = {
      type: "loop",
      arrows: false,
      pagination: false,
      autoWidth: true,
      autoplay: false,
      focus: "center",
      drag: false,
      gap: "0",
      autoScroll: {
        autoplay: true,
        speed: 1,
        pauseOnHover: false,
        pauseOnFocus: false,
      }
    }
    if(targetElm.dataset.speed) {
      options.autoScroll.speed = targetElm.dataset.speed;
    }

    if(targetElm.dataset.gap) {
      options.gap = targetElm.dataset.gap;
    }

    const slider = new Splide(targetElm, options);
    slider.mount({AutoScroll});
  }
}


const init = () => {
  // carousel();
  marquee();
}
export default init;